export default "__VITE_ASSET__DVvlVFVa__"